var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-upload',{attrs:{"action":_vm.url,"headers":_vm.headers,"multiple":_vm.multiple,"name":"uploadFile","data":{
      asImage: _vm.asImage,
      fieldName: _vm.fieldName,
      model: _vm.uplaodModel,
    },"on-success":_vm.handleAvatarSuccess,"on-change":_vm.handleAvatarChange,"show-file-list":false}},[_c('el-button',{attrs:{"loading":_vm.loading,"disabled":_vm.loading,"type":"primary","icon":_vm.icon,"size":_vm.size}},[_vm._v(_vm._s(_vm.topTitle))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }